export const DEFAULT_ACTION = "app/SearchCase/DEFAULT_ACTION";
export const SEARCH_CASE_VALUE = 'app/SearchCase/SEARCH_CASE_VALUE';
